import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useUniqueId, useFormField, useCallback } from 'sb-hooks'
import { FormattedMessage } from 'sb-react-intl'

import s from './SimpleSelect.scss'


const SimpleSelect = ({ className, field, options, placeholder, ariaLabel, onChange }) => {
  const id = `simpleSelect_${useUniqueId()}`

  const { value, error, set } = useFormField(field)

  const handleChange = useCallback((event) => {
    set(event.target.value)

    if (typeof onChange === 'function') {
      onChange(event.target.value)
    }
  }, [ set ])

  const errorMessage  = field ? field.error : error
  const selectValue   = field ? field.value : value

  const rootClassName = cx(s.selectRoot, className, {
    [s.errored]: Boolean(errorMessage),
  })

  const selectClassName = cx(s.select, {
    [s.selectValue]: selectValue,
  })

  const placeholderClassName = cx(s.placeholder, {
    [s.placeholderOpened]: selectValue,
  })

  let errorNode

  if (typeof errorMessage === 'string') {
    errorNode = error
  }
  else if (errorMessage) {
    errorNode = (
      <FormattedMessage {...errorMessage} />
    )
  }

  return (
    <div className={rootClassName}>
      <div className={s.selectContainer}>
        {
          Boolean(placeholder) && (
            <FormattedMessage className={placeholderClassName} tag="label" {...placeholder} htmlFor={id} />
          )
        }
        <select
          id={id}
          className={selectClassName}
          value={selectValue === null ? undefined : selectValue}
          autoComplete="off"
          aria-label={ariaLabel}
          onChange={handleChange}
        >
          {
            !selectValue && (
              <option value={null} />
            )
          }
          {
            options.map(({ title, value }) => (
              <option key={value} value={value}>{title}</option>
            ))
          }
        </select>
      </div>
      {
        Boolean(errorMessage) && (
          <div className={s.error}>{errorNode}</div>
        )
      }
    </div>
  )
}

SimpleSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
  })).isRequired,
}


export default SimpleSelect
